import { PermissionSearchRequest } from '@trukt/tms-api/UserRoleService';
import { createKey } from '../../createKey';

const keyHandler = createKey('user-role-permissions');

export const PermissionsServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<PermissionSearchRequest>(),
};
